import base from './base'

export default {
  // 发送手机验证码
  sendMobileCode(params) {
    return base.post('/utils/verification_code/sendMobileCode', params)
  },

}
